import { render } from "./flickity.vue?vue&type=template&id=79309414"
import script from "./flickity.vue?vue&type=script&lang=js"
export * from "./flickity.vue?vue&type=script&lang=js"

import "flickity/dist/flickity.css?vue&type=style&index=0&lang=css"
script.render = render

export default script